export const yacanConfig = {
  connection: {
    title: "Conexión con YACAN",
    subtitle:
      "Conecta tu cuenta de YACAN para gestionar el acceso de tus huéspedes con tus cerraduras.",
    connected: "Cuenta conectada",
    notConnected: "Sin conectar",
    info:
      "Al pulsar <b>Conectar con YACAN</b> se abrirá una ventana para iniciar sesión y autorizar el acceso. La conexión queda guardada para toda tu cuenta y se usa en todas tus propiedades.",
    connect: "Conectar con YACAN",
    waiting: "Esperando autorización...",
    connectedTitle: "Cuenta de YACAN conectada",
    authActive: "Autorización activa",
    reauthorize: "Reautorizar",
    reauthorizeTitle: "Volver a autorizar",
    disconnect: "Desconectar",
  },
  locks: {
    title: "Cerraduras para esta propiedad",
    subtitle:
      "Selecciona las cerraduras de YACAN que aplican a <b>esta propiedad</b>.",
    selectedCount: "{count} seleccionada(s)",
    noneFound: "No se encontraron cerraduras en tu cuenta YACAN.",
    refresh: "Actualizar",
    placeholder: "Selecciona cerraduras…",
    summary: "{count} cerradura(s) seleccionada(s)",
    empty: "Ninguna cerradura seleccionada",
    lockFallback: "Cerradura {id}",
    save: "Guardar cerraduras de esta propiedad",
    saving: "Guardando...",
  },
  assign: {
    title: "Asignación (PMS)",
    subtitle:
      "Asigna cada cerradura a <b>Puerta principal</b>, <b>Unidad</b> o <b>Portón</b>.",
    assignedCount: "{count} asignada(s)",
    info:
      "Con YACAN, el <b>acceso del huésped lo gestiona YACAN</b> a partir de la reserva: no se generan PINs desde aquí. Al confirmar una reserva, se sincroniza automáticamente con YACAN.",
    lockFallback: "Cerradura {id}",
    assignmentLabel: "Asignación",
    typeNone: "Sin asignar",
    typeCommon: "Puerta principal (común)",
    typeUnit: "Puerta de apartamento",
    typeGate: "Portón / Garaje",
    unitLabel: "Unidad / Alojamiento",
    unitPlaceholder: "Selecciona una unidad",
    unitFallback: "Unidad {id}",
    save: "Guardar asignación",
    saving: "Guardando...",
  },
  msg: {
    connectStartError: "No se pudo iniciar la conexión con YACAN",
    popupBlocked: "Permite las ventanas emergentes para conectar con YACAN.",
    connectError: "Error al conectar con YACAN",
    connectSuccess: "Cuenta de YACAN conectada correctamente",
    connectFailed: "No se pudo conectar con YACAN",
    disconnectConfirm:
      "¿Desconectar tu cuenta de YACAN? Las reservas dejarán de sincronizarse con YACAN.",
    disconnectSuccess: "Cuenta de YACAN desconectada",
    disconnectError: "No se pudo desconectar",
    locksLoadError: "No se pudieron cargar las cerraduras",
    locksLoadError2: "Error cargando cerraduras de YACAN",
    selectAtLeastOne: "Selecciona al menos una cerradura.",
    lockDefaultName: "Cerradura YACAN",
    locksSaved: "Cerraduras guardadas para esta propiedad",
    locksSaveError: "No se pudieron guardar las cerraduras",
    saveError: "Error al guardar",
    selectUnitForApartment:
      "Selecciona la unidad para las cerraduras de tipo 'Puerta de apartamento'.",
    assignSaved: "Asignación guardada correctamente",
    assignSaveError: "No se pudo guardar la asignación",
    assignSaveError2: "Error al guardar asignación",
  },
};
